@if (drawerOpen()) {
  <div class="scrim" aria-hidden="true" (click)="onCloseSidebar()"></div>
}

<div
  #rail
  class="if-sidenav-cabinet"
  [id]="railId"
  [class.collapsed]="collapsed()"
  [class.mobile-open]="drawerOpen()"
  [attr.role]="drawerOpen() ? 'dialog' : null"
  [attr.aria-modal]="drawerOpen() ? 'true' : null"
  [attr.aria-label]="drawerOpen() ? 'Navigation' : null"
  (keydown)="onRailKeydown($event)">
  @if (drawerOpen()) {
    <div class="drawer-head">
      <app-logo customClass="drawer-logo" [decorative]="true" />
      <button #closeButton type="button" class="rail-button drawer-close" aria-label="Close navigation" (click)="onCloseSidebar()">
        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" aria-hidden="true" focusable="false">
          <path stroke-linecap="round" stroke-linejoin="round" d="M6 18 18 6M6 6l12 12" />
        </svg>
      </button>
    </div>
  }

  <nav class="rail-nav" [attr.aria-label]="navLabel()">
    <div class="rail-scroll">
      <ng-content></ng-content>
    </div>
    <div class="rail-pinned">
      <ng-content select="[railPinned]"></ng-content>
    </div>
  </nav>

  @if (!narrow()) {
    <div class="rail-footer">
      <button
        type="button"
        class="rail-button rail-toggle"
        [attr.aria-expanded]="!collapsed()"
        [attr.aria-controls]="railId"
        [appTooltip]="'Expand sidebar'"
        tooltipPosition="right"
        [tooltipDisabled]="!collapsed()"
        (click)="onToggleSidebar()">
        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" aria-hidden="true" focusable="false">
          <path stroke-linecap="round" stroke-linejoin="round" d="M18.75 19.5 11.25 12l7.5-7.5m-6 15L5.25 12l7.5-7.5" />
        </svg>
        <span class="rail-toggle-label">{{ collapsed() ? 'Expand sidebar' : 'Collapse sidebar' }}</span>
      </button>
    </div>
  }
</div>
